import { render, staticRenderFns } from "./upload-rule.vue?vue&type=template&id=554e8c6a&scoped=true"
import script from "./upload-rule.vue?vue&type=script&lang=js"
export * from "./upload-rule.vue?vue&type=script&lang=js"
import style0 from "./upload-rule.vue?vue&type=style&index=0&id=554e8c6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e8c6a",
  null
  
)

export default component.exports